import {
  StatusActiveIcon,
  StatusInactiveIcon,
} from '../icons/StatusIcons';
import type { StatusDropdownConfigMap } from '@/components/ui/status-dropdown';

// Active/Inactive config for the OrderSource status dropdown.
//
// Functionally identical to InventoryDetails/inventory-status-config and
// ResaleItem/resale-item-status-config. Duplicated here intentionally to
// keep OrderSources self-contained — extracting to a shared primitive can
// happen when there's deliberate appetite to migrate all 3 callsites.
export type OrderSourceStatus = 'active' | 'inactive';

export function createOrderSourceStatusDropdownConfig(
  labels?: Record<OrderSourceStatus, string>,
): StatusDropdownConfigMap<OrderSourceStatus> {
  const l = labels ?? { active: 'Active', inactive: 'Inactive' };

  return {
    active: {
      label: l.active,
      activeTextClassName: 'text-confirmed-green',
      inactiveTextClassName: 'text-grey',
      icon: (isActive) => (
        <StatusActiveIcon className={isActive ? 'text-confirmed-green' : 'text-grey'} />
      ),
    },
    inactive: {
      label: l.inactive,
      activeTextClassName: 'text-grey',
      inactiveTextClassName: 'text-grey',
      icon: () => <StatusInactiveIcon className="text-grey" />,
    },
  };
}
